// module.exports = {
//   // DOMAIN_NAME: 'https://staging.afya.chat',
//   // ADMIN_DOMAIN_NAME: 'https://staging.afya.chat',
//   DOMAIN_NAME: "https://backend.test-afya.afya.chat",
//   ADMIN_DOMAIN_NAME: "https://backend.test-afya.afya.chat",
//   //  DOMAIN_NAME: 'https://uat.afya.chat',
//   //  ADMIN_DOMAIN_NAME: 'https://uat.afya.chat',
//   // IMAGE_PATH: "http://13.124.91.53/static/media/images/",
//   // PROFILE_PATH: "http://13.124.91.53/static/media/images/profilepic/",
//   // NEWS_IMAGE_PATH: "http://13.124.91.53/static/media/images/breakingnewsimages/",
// };

const { REACT_APP_ENV: appEnv } = process.env;

const backendUrl =
  appEnv === "prod" ? "https://backend.afya.chat"
    : appEnv === "uat" ? "https://uat-test.afya.chat"
    : appEnv === "local" ? "http://localhost:3000/"
    : "https://staging-test.afya.chat";

module.exports = {
  DOMAIN_NAME: backendUrl,
  ADMIN_DOMAIN_NAME: backendUrl,
};
